import { Component } from '@angular/core';

@Component({
    selector: 'app-gauge-graph-table-header',
    templateUrl: './gauge-graph-table-header.component.html',
    styleUrl: './gauge-graph-table-header.component.css',
    standalone: false,
})
export class GaugeGraphTableHeaderComponent {
    isInfoMessageVisible: boolean = false;
}
